export default __webpack_public_path__ + "static/media/angry.ab3ab413.png";